import React from "react";

const NoResult = () => {
  return (
    <div className="h-[100dvh] w-screen flex items-center justify-center">
      <span className="text-md font-bold">No Result Found!</span>
    </div>
  );
};

export default NoResult;
